import { createContext, useContext, useEffect, useState } from 'react';

// FEAT-013 — 인증은 서버(functions/_middleware.ts)에서 결정된다.
//   - Entra OIDC 세션 쿠키(rd_session) 또는 (병행 단계) Cloudflare Access 헤더.
// 클라이언트는 /api/user/me 로 현재 사용자 정보를 조회한다. 세션이 없고 헤더 신뢰도
// 꺼진(Phase 2) 경우 /api/user/me 는 401 → login() 으로 /auth/login 리다이렉트.
const AuthContext = createContext({
  userEmail: null,
  isAdmin: false,
  loading: true,
  refresh: () => {},
  login: () => {},
  logout: () => {},
});

// 로그인 후 현재 위치로 복귀
function loginRedirect() {
  const ret = encodeURIComponent(window.location.pathname + window.location.search);
  window.location.href = `/auth/login?return=${ret}`;
}

export function AuthProvider({ children }) {
  const [state, setState] = useState({ userEmail: null, isAdmin: false, loading: true });

  async function fetchMe() {
    try {
      const res = await fetch('/api/user/me');
      if (res.status === 401) {
        // Phase 2 미인증 — 로그인으로 유도
        loginRedirect();
        return;
      }
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setState({ userEmail: data.userEmail, isAdmin: !!data.isAdmin, loading: false });
    } catch {
      setState({ userEmail: null, isAdmin: false, loading: false });
    }
  }

  useEffect(() => { fetchMe(); }, []);

  const login = () => loginRedirect();
  const logout = () => { window.location.href = '/auth/logout'; };

  return (
    <AuthContext.Provider value={{ ...state, refresh: fetchMe, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
